import React, {useEffect, useState} from "react";
import {makeStyles} from '@mui/styles';

const Layout = props => {
    const classes = useStyles();

    return (
        <div className={classes.wrap}>
            <div className={classes.header}>
                <img src="/images/commerz_logo.png" alt="logo" width={250}/>
                <span className={classes.headerText}>Få ut mer av ditt verksamhetssystem</span>
            </div>
            {props.children}
            <footer className={classes.footer}>
                <div className={classes.progressContainer}>
                    <div className={classes.progressBar} style={{width: `${(props.progress / 20) * 100}%`}}/>
                </div>
                <div className={classes.dotsWraps}>
                    {[0, 1].map((item, index) => (
                        <div className={classes.dot} key={index}>
                            {index === props.currentIndex &&
                                <div className={classes.activeDot}>
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </footer>
            <div className={classes.circle}></div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    wrap: {
        width: "100%",
        height: "100vh",
        position: "relative",
        backgroundColor: "#ffffff",
        overflow: "hidden",
    },
    circle: {
        content: '',
        position: "absolute",
        top: "50%",
        right: "-750px",
        width: 1500,
        height: 1500,
        backgroundColor: "#eaf7fa",
        borderRadius: "50%",
        transform: "translateY(-50%)",
    },
    header: {
        background: "transparent",
        padding: "30px 30px 50px 30px",
        display: "flex",
        justifyContent: "space-between",
        zIndex: 1,
        position: "relative",
        alignItems: "center",
    },
    headerText: {
        fontSize: 26,
        fontWeight: 600
    },
    footer: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        zIndex: 1
    },
    dotsWraps: {
        padding: 20,
        display: "flex",
        justifyContent: "center",
        background: "#ffffff"
    },
    dot: {
        borderRadius: "50%",
        content: '',
        width: 20,
        height: 20,
        border: "1px solid #707070",
        margin: "0 7px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    activeDot: {
        borderRadius: "50%",
        content: '',
        width: 10,
        height: 10,
        background: "#14a15f"
    },
    progressContainer: {
        width: '100%',
        height: 5,
        backgroundColor: '#e0e0e0',
        overflow: 'hidden',
    },
    progressBar: {
        height: "100%",
        backgroundColor: "#14a15f",
        transition: "width 1s linear"
    }
}));

export default Layout;